<script setup lang="ts">
import { router } from "@inertiajs/vue3"
import { ref } from "vue"
import { Menu } from "lucide-vue-next"
import Toaster from "@/components/ui/toast/Toaster.vue"
import { Button } from "@/components/ui/button"
import { usePages } from "@/use-pages"
import { useFramesStore, TheFramesDrawer } from "@components/ui/frames"
import AppSidebar from "./AppSidebar.vue"

const frames = useFramesStore()
const sidebarCollapsed = ref(false)
const mobileOpen = ref(false)

let { pages } = usePages()
pages = Object.fromEntries(Object.entries(pages).map(([path, component]) => [path.replace("./pages/", ""), component]))

window.addEventListener("popstate", () => {
    frames.frames.forEach((frame) => {
        frames.close(frame)
    })
})

router.on("navigate", () => {
    frames.frames.forEach((frame) => {
        frames.close(frame)
    })
    mobileOpen.value = false
})
</script>

<template>
    <div class="app-layout layout--app flex min-h-screen bg-background">
        <AppSidebar v-model:collapsed="sidebarCollapsed" v-model:mobile-open="mobileOpen" />

        <div class="flex min-w-0 flex-1 flex-col">
            <div class="print-hide sticky top-0 z-30 flex h-14 items-center gap-3 border-b bg-white px-4 lg:hidden">
                <Button type="button" variant="ghost" size="icon" @click="mobileOpen = true">
                    <Menu class="h-5 w-5" />
                    <span class="sr-only">Open menu</span>
                </Button>
                <div class="flex items-center gap-2">
                    <img src="/images/antahan-logo.svg" alt="Antahan Café" class="h-8 w-auto" />
                    <span class="text-sm font-semibold text-gray-900">Antahan Café</span>
                </div>
            </div>

            <main class="flex-1">
                <div class="w-full px-4 py-6 sm:px-6 lg:px-8 print:px-0 print:py-0">
                    <slot />
                </div>
            </main>
        </div>

        <div class="print-hide">
            <Toaster />
        </div>

        <div class="print-hide">
            <TheFramesDrawer :pages="pages" />
        </div>
    </div>
</template>
